export default __webpack_public_path__ + "static/media/AnywhereFitness.9f0be6dc.jpg";